import React from "react";
import "./switchButton.css";

export const SwitchButton = ({ checked, onClick }) => {
  return (
    <div className="switch-button">
      <div className="d-flex">
        <button onClick={onClick}>
          <input type="checkbox" checked={checked} />
          <span className="slider"></span>
        </button>
      </div>
    </div>
  );
};
